export const FACTOR_THRESHOLDS = {
  good: 1.5,
  warning: 2.5,
} as const;

export const FACTOR_COLORS = {
  good: '#38a169',    // green.500
  warning: '#dd6b20', // orange.500
  bad: '#e53e3e',     // red.500
} as const;

export function factorColor(value: number | null): string {
  if (value == null) return '#A0AEC0'; // gray.400
  if (value <= FACTOR_THRESHOLDS.good) return FACTOR_COLORS.good;
  if (value <= FACTOR_THRESHOLDS.warning) return FACTOR_COLORS.warning;
  return FACTOR_COLORS.bad;
}

export function secondsToHours(seconds: number): number {
  return Math.round((seconds / 3600) * 100) / 100;
}

export function formatDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return `${h}h ${m}m`;
}

export function formatFactor(value: number | null): string {
  if (value == null) return '—';
  return `${value.toFixed(2)}x`;
}

export function formatWeekLabel(year: number, week: number): string {
  return `KW${week}/${year}`;
}

// Generate distinct colors for employees in stacked charts
const EMPLOYEE_PALETTE = [
  '#3182ce', '#63b3ed', '#90cdf4', '#2c5282', '#bee3f8',
  '#805ad5', '#b794f4', '#d6bcfa', '#553c9a', '#e9d8fd',
  '#d69e2e', '#ecc94b', '#f6e05e', '#975a16', '#fefcbf',
  '#38a169', '#68d391', '#9ae6b4', '#276749', '#c6f6d5',
  '#e53e3e', '#fc8181', '#feb2b2', '#9b2c2c', '#fed7d7',
];

export function employeeColor(index: number): string {
  return EMPLOYEE_PALETTE[index % EMPLOYEE_PALETTE.length];
}
